import JQuery from 'jquery';

let $ = JQuery;

// const url = new URL('http://192.168.1.251/demirag-api/admin/'); // yeni sunucu
// const url = new URL('http://192.168.1.108/demirag-api/admin/'); // Enes Cemcir
// const url = new URL("http://89.252.181.10/demirag-api/admin/"); //10. sunucu
// const url = new URL('http:localhost/demirag-api/admin/');
// const url = new URL('http://localhost/demirag-api/admin/');
const url = new URL('https://flowpro.demiragosb.org.tr/demirag-api/admin/');

var WSProvider = {
    apiPath: url,
    path: url.origin + '/demirag/',
    documentPath: url + 'belge/evrak/yazi_isleri/',
    documentPath2: url + '../../demirag-api/admin/belge/personel/ozluk/resim',
    // imagePath: url + 'demirag-api/admin/belge/upload/', // Resimler bazı projelerde buyuk - orta ve kucuk olarak ölceklendiriliyor. Küçük projelerde tek boyut olabiliyor.
    imagePath: url + 'belge/yonetim/resim/',
    imagePathBuyuk: url + '../../demirag-api/admin/belge/upload/buyuk/',
    imagePathOrta: url + '../../demirag-api/admin/belge/upload/orta/',
    imagePathKucuk: url + '../../demirag-api/admin/belge/upload/kucuk/',
    dekontPath: url + '../../demirag-api/admin/belge/muhasebe/dekont/',
    veriPath: url + '../../demirag-api/admin/belge/log/',
    variablePath: url + '../../demirag-api/admin/',
    yatirimciLogo: url + '../../demirag-api/admin/',
    izin: url + '../../demirag-api/admin/belge/izin/dosya/',

    ajaxPost: function (serviceName, jsonParams) {
        var form_data = new FormData(); // Gelen değerleri form data objesine cevirme. Daha cok array gönderebilmek için yazıldı! Önceden arrayler stringe cevrilip gönderiliyormuş :))
        for (var key in jsonParams) {
            if (Array.isArray(jsonParams[key])) {
                // Gelen deger array mi?
                if (jsonParams[key].length > 0) {
                    // Gelen array içindeki de array mi?
                    for (var i = 0; i < jsonParams[key].length; i++) {
                        form_data.append(key + '[]', jsonParams[key][i]); // Formdata'ya array olan elemanları ekleme
                    }
                } else {
                    form_data.append(key + '[]', '');
                }
            } else form_data.append(key, jsonParams[key]);
        }
        var service = new Promise(function (resolve, reject) {
            return $.ajax({
                type: 'POST',
                url: url + serviceName + '.php',
                datatype: 'json',
                processData: false, // Important!
                contentType: false,
                data: form_data,
                success: function (result) {
                    if (result) {
                        resolve(result);
                    } else {
                        resolve();
                    }
                },
                error: function (request) {
                    if (request) {
                        reject(request);
                    } else {
                        reject();
                    }
                },
            });
        });
        return service;
    },
};
export default WSProvider;
